import gql from 'graphql-tag';
import { UrlAliasAllData } from '../fragments';

export default gql`
mutation deleteUrlAlias (
    $id: ID!
) {
    deleteUrlAlias (id: $id) {
        ...UrlAliasAllData
    }
}
${UrlAliasAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/deleteUrlAlias.ts